// Material Dashboard 2 PRO React example components

// MUI Components
import { TableContainer, Table, TableHead, TableRow, TableBody } from '@mui/material';

// Table Components
import DataTableHeadCell from 'examples/Tables/DataTable/DataTableHeadCell';
import DataTableBodyCell from 'examples/Tables/DataTable/DataTableBodyCell';
import MDBox from 'components/MDBox';

// Cell Components
import DefaultCell from 'layouts/projects/Components/Offer/components/DemandsTable/data/components/DefaultCell';
import ShortTitleCell from 'layouts/projects/Components/Offer/components/DemandsTable/data/components/ShortTitleCell';
import PriceCell from 'layouts/projects/Components/Offer/components/DemandsTable/data/components/PriceCell';
import TitleCell from 'layouts/projects/Components/Offer/components/DemandsTable/data/components/TitleCell';
import DiscountCell from 'layouts/projects/Components/Offer/components/DemandsTable/data/components/DiscountCell';

// Helper
import { availableDemandNames } from 'helpers/projectHelpers';

function DemandsTable({ demand }) {
    if (demand == null) return null;

    // Generate rows data
    const rows = [];
    Object.keys(demand).forEach((key) => {
        if (availableDemandNames.includes(key)) {
            demand[key].forEach((el) => {
                let temporaryView = {
                    kisaBaslik: [key, { image: el.gorsel ? el.gorsel : key }],
                    baslik: el,
                    verilenFiyat: el,
                    indirimOrani: el.indirimOrani,
                    miktar: el.miktar,
                    toplam: el,
                };
                rows.push(temporaryView);
            });
        }
    });

    return (
        <TableContainer>
            <Table>
                <MDBox component="thead">
                    <TableRow>
                        <DataTableHeadCell width="auto" align="left">
                            Başlık
                        </DataTableHeadCell>
                        <DataTableHeadCell width="auto" align="left">
                            Açıklama
                        </DataTableHeadCell>
                        <DataTableHeadCell width="auto" align="right">
                            Fiyat
                        </DataTableHeadCell>
                        <DataTableHeadCell width="auto" align="center">
                            Miktar
                        </DataTableHeadCell>
                        <DataTableHeadCell width="auto" align="center">
                            İskonto
                        </DataTableHeadCell>
                        <DataTableHeadCell width="auto" align="right">
                            Toplam
                        </DataTableHeadCell>
                    </TableRow>
                </MDBox>
                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow key={index}>
                            <DataTableBodyCell align="left">
                                <ShortTitleCell
                                    image={row.kisaBaslik[1].image}
                                    color={row.kisaBaslik[1].color || 'dark'}
                                    name={row.kisaBaslik[0]}
                                />
                            </DataTableBodyCell>
                            <DataTableBodyCell align="left">
                                <TitleCell name={row.baslik.baslik} data={row.baslik} />
                            </DataTableBodyCell>
                            <DataTableBodyCell align="right">
                                <PriceCell
                                    price={row.verilenFiyat.verilenFiyat}
                                    amount={1}
                                    discount={row.verilenFiyat.indirimOrani}
                                    data={row.verilenFiyat}
                                    demand={demand}
                                />
                            </DataTableBodyCell>
                            <DataTableBodyCell align="center">
                                <DefaultCell value={row.miktar} />
                            </DataTableBodyCell>
                            <DataTableBodyCell align="center">
                                <DiscountCell discount={row.indirimOrani} demand={demand} />
                            </DataTableBodyCell>
                            <DataTableBodyCell align="right">
                                <PriceCell
                                    price={row.toplam.verilenFiyat}
                                    amount={row.toplam.miktar}
                                    discount={row.toplam.indirimOrani}
                                    data={row.toplam}
                                    demand={demand}
                                />
                            </DataTableBodyCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default DemandsTable;
